// ToDo: zastanowić się gdzie ten plik ułożyć w strukturze folderu
export const DEFAULT_PAGE_SIZE = 30
export const DEFAULT_PAGE_SIZE_FOR_LIST_VIEW = 40
export const START_FROM = 0
export const MAX_ROWS_FOR_FETCH_FULL_LIST = 100000;


// ToDo: przenieść do modułu historii po jego powstaniu
export const DEFAULT_PAGE_SIZE_FOR_HISTORY = 24



// WEBPACK FOOTER //
// ./src/constants.ts